import * as types from '../types'

/**
 * 商品分类
 * topData: 商品顶级分类的缩略图
 * topList: 商品顶级分类列表
 * categoryList: 商品分类数组(全)
 * curGoodsList: 当前分类下的商品列表
 * farmerIds: 当前分类下可筛选的农友id数组
 * maxPrice: 当前分类下商品最高价格
 * @type {Object}
 */
const state = {
    topData: [
        {
            id: 1,
            title: '当季蔬菜',
            desc: '有机标准种植的蔬菜，安全新鲜、味道浓郁',
            thumb: 'category/thumbs/cat-1.png',
            more: 'category/more/more1.png'
        },
        {
            id: 2,
            title: '当季水果',
            desc: '当天采摘，当天到家，甜的回味自然',
            thumb: 'category/thumbs/cat-2.png',
            more: 'category/more/more2.png'
        },
        {
            id: 3,
            title: '散养禽蛋',
            desc: '大面积原粮散养，没有颗粒饲料和激素，味美放心',
            thumb: 'category/thumbs/cat-3.png',
            more: 'category/more/more3.png'
        },
        {
            id: 5,
            title: '原粮肉类',
            desc: '超长生长期的原粮喂养，肉香且紧致',
            thumb: 'category/thumbs/cat-5.png',
            more: 'category/more/more4.png'
        },
        {
            id: 6,
            title: '粮油副食',
            desc: '可持续化种植方式，本地大米不比五常逊色',
            thumb: 'category/thumbs/cat-6.png',
            more: 'category/more/more5.png'
        },
        {
            id: 7,
            title: '野生水产',
            desc: '“日渐稀缺”的自然食材，舌尖上的鲜美',
            thumb: 'category/thumbs/cat-7.png',
            more: 'category/more/more6.png'
        },
        {
            id: 8,
            title: '休闲食品',
            desc: '原生态、无添加，入口纯正，好吃地停不下来',
            thumb: 'category/thumbs/cat-8.png',
            more: 'category/more/more7.png'
        },
        {
            id: 9,
            title: '安全套餐',
            desc: '更实惠、更方便、更丰富、更速度',
            thumb: 'category/thumbs/cat-9.png',
            more: 'category/more/more8.png'
        },
        {
            id: 10,
            title: '苗木农资',
            desc: '庭前屋后，看花开花落，品甜美多汁',
            thumb: 'category/thumbs/cat-10.png',
            more: 'category/more/more9.png'
        },
        {
            id: 100,
            title: '优惠推选',
            desc: '每一次折扣，都是想回馈您给予的鼓励',
            thumb: 'category/thumbs/cat-0.jpg',
            more: ''
        }
    ],
    topList: [],
    categoryList: [],
    curGoodsList: [],
    maxPrice: 700,
    farmerIds: [1,2,3,4,5,6,7,8,9]
}

const getters = {

}

const actions = {

}

const mutations = {
    [types.CHANGE_TOP_CATEGORIES] (state, category) {
        state.topList = category
    },

    [types.CHANGE_CATEGORY_LIST] (state, list) {
        state.categoryList = list
    },

    [types.CHANGE_CUR_GOODS] (state, list) {
        state.curGoodsList = list
    },

    [types.AJAX_UPDATE_GOODS] (state, list) {
        state.curGoodsList = state.curGoodsList.concat(list)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/category.js